import { SELL_API as axios } from '@services/axiosInstance';
import type { ServiceQualificationRequest, ServiceQualificationResult } from '@t/serviceQualification.types';

export const serviceQualification = async (
  sessionId: string,
  payload: ServiceQualificationRequest
): Promise<ServiceQualificationResult> => {
  const { data } = await axios.post<ServiceQualificationResult>(`/sessions/${sessionId}/serviceQualification`, payload);
  return data;
};
